import Request from "./Request";

class Api {
  constructor() {
    this.request = new Request();
  }

  /**
   * @param {function} sessionExpiredAction - A redux action which will be dispatch if session is expired
   */
  init({ sessionExpiredAction }) {
    this.request.init({
      sessionExpiredAction,
    });
  }

  // ================================ APIs =================================

  login(data) {
    return this.request.post("/api/v1/auth/login", null, data);
  }

  getBusinessInformation() {
    return this.request.get("/api/v1/business-infos", null, null);
  }

  getCheckSubDomain() {
    return this.request.get("/api/v1/auth/init", null, null);
  }

  updateBusinessInformation(data) {
    return this.request.patch("/api/v1/business-infos", null, data);
  }

  getTerms() {
    return this.request.get("/api/v1/terms", null, null);
  }

  updateTerms(data) {
    return this.request.patch("/api/v1/terms", null, data);
  }

  getPayments() {
    return this.request.get("/api/v1/payments", null, null);
  }

  getPaymentDetails(id) {
    return this.request.get(`/api/v1/payments/${id}`, null, null);
  }

  createPayment(data) {
    return this.request.post("/api/v1/payments", null, data);
  }

  updatePayment({ id, ...data }) {
    return this.request.patch(`/api/v1/payments/${id}`, null, data);
  }

  updatePaymentStatus(id) {
    return this.request.patch(`/api/v1/payments/${id}/change-status`, null, {});
  }

  deletePayment(id) {
    return this.request.delete(`/api/v1/payments/${id}`, null, {});
  }

  getCountries() {
    return this.request.get("/api/v1/countries", null, null);
  }

  createCountry(data) {
    return this.request.post("/api/v1/countries", null, data);
  }

  editCountry({ id, ...data }) {
    return this.request.patch(`/api/v1/countries/${id}`, null, data);
  }

  deleteCountry(id) {
    return this.request.delete(`/api/v1/countries/${id}`, null, {});
  }

  updateCountryStatus(id) {
    return this.request.patch(
      `/api/v1/countries/${id}/change-status`,
      null,
      {}
    );
  }

  getCities(data) {
    return this.request.get(`/api/v1/cities`, data, null);
  }

  getCityById(id) {
    return this.request.get(`/api/v1/cities/${id}`, null, null);
  }

  createCities(data) {
    return this.request.post(`/api/v1/cities`, null, data);
  }

  editCity({ id, ...data }) {
    return this.request.patch(`/api/v1/cities/${id}`, null, data);
  }

  deleteCity(id) {
    return this.request.delete(`/api/v1/cities/${id}`, null, {});
  }

  updateCityStatus(id) {
    return this.request.patch(`/api/v1/cities/${id}/change-status`, null, {});
  }

  createTownships(data) {
    return this.request.post(`/api/v1/townships`, null, data);
  }

  editTownship({ id, ...data }) {
    return this.request.patch(`/api/v1/townships/${id}`, null, data);
  }

  deleteTownship(id) {
    return this.request.delete(`/api/v1/townships/${id}`, null, {});
  }

  getProductOptions() {
    return this.request.get(`/api/v1/product-variants`, null, null);
  }

  getProductOptionDetail(id) {
    return this.request.get(`/api/v1/product-variants/${id}`, null, null);
  }

  createProductOptions(data) {
    return this.request.post(`/api/v1/product-variants`, null, data);
  }

  editProductOption({ id, ...data }) {
    return this.request.patch(`/api/v1/product-variants/${id}`, null, data);
  }

    getOrders({
      status,
      keyword,
      sort,
      has_delivery_request,
      date_from,
      date_to,
      from_deli,
      page,
      page_size,
    }) {
      let data = {
        status,
        sort,
        has_delivery_request,
        page,
        page_size,
      };

      if (keyword) {
        data.search = keyword;
      }

      if (from_deli) {
        data.from_deli = from_deli;
      }

      if (date_from && date_to) {
        data.date_from = date_from;
        data.date_to = date_to;
      }

      return this.request.get(`/api/v1/orders`, data, null);
    }

  getOrderDetails(id) {
    return this.request.get(`/api/v1/orders/${id}`, null, null);
  }

  confirmOrder(id,data) {
    return this.request.patch(`/api/v1/orders/${id}/confirm`, null, data);
  }

  rejectOrder(id) {
    return this.request.patch(`/api/v1/orders/${id}/reject`, null, {});
  }

  cancelAllOrders({ id, cancel_type, cancel_reason, cancellation_reason }) {
    const data = {
      cancel_type,
      cancel_reason,
      cancellation_reason,
    };
    return this.request.patch(`/api/v1/orders/${id}/cancel`, null, data);
  }

  cancelOrderProducts(orderId, orderProducts) {
    const payload = {
      order_products: orderProducts.map((item) => ({
        id: item.p_id,
        // p_id: item.p_id,
        // product_id: item.product_id,
        // variant_id: item.variant_id, // if needed
        // cancel_reason: item.cancel_reason,
        cancellation_reason: {
            primary: item.cancel_reason.primary,
            secondary: item.cancel_reason.secondary,
          },
      })),
    };

    return this.request.patch(
      `/api/v1/orders/${orderId}/cancel-multiple-products`,
      null,
      payload
    );
  }

  getSubCategories(data) {
    return this.request.get(`/api/v1/sub-categories`, data, null);
  }

  getCatalogues(data) {
    return this.request.get(`/api/v1/catalogues`, data, null);
  }

  getBrands({ is_active }) {
    let data = {};
    if (is_active !== undefined) {
      data.is_active = is_active;
    }
    return this.request.get(`/api/v1/brands`, data, null);
  }

  getCustomerLoginMethods() {
    return this.request.get(`/api/v1/social-login-settings`, null, null);
  }
  getAllCancelReason() {
    let data = {
      sort: "sort:asc",
    };
    return this.request.get(`/api/v1/cancel-reasons`, data, null);
  }
  getCancelReason() {
    let data = {
      status: true,
    };
    return this.request.get(`/api/v1/cancel-reasons`, data, null);
  }
  createCancelReason(payload) {
    return this.request.post(`/api/v1/cancel-reasons`, null, payload);
  }
  editCancelReason({ id, ...data }) {
    return this.request.patch(`/api/v1/cancel-reasons/${id}`, null, data);
  }
  changeCancelReasonStatus(id) {
    return this.request.patch(
      `/api/v1/cancel-reasons/${id}/toggle-status`,
      null,
      {}
    );
  }
  deleteCancelReason(id) {
    return this.request.delete(`/api/v1/cancel-reasons/${id}`, null, {});
  }
  changeLoginStatus(id) {
    return this.request.patch(
      `/api/v1/social-login-settings/${id}/change-status`,
      null,
      {}
    );
  }
  getPanelInfo() {
    return this.request.get(`/api/v1/dashboard/editor-panel-info`, null, null);
  }

  getProducts({
    page = 1,
    page_size = 10,
    sort,
    sub_category_id,
    catalogue_id,
    category_id,
    brand_id,
    search,
  }) {
    let data = {
      page,
      page_size,
      sort,
      sub_category_id,
      catalogue_id,
      category_id,
      brand_id,
      search,
      sort: "created_at:desc",
    };
    return this.request.get(`/api/v1/products`, data, null);
  }

  getTopProducts({ page = 1, page_size = 10 }) {
    let data = {
      page,
      page_size,
    };
    return this.request.get(
      `/api/v1/dashboard/top-selling-products`,
      data,
      null
    );
  }

  getProductDetails(id) {
    return this.request.get(`/api/v1/products/${id}`, null, null);
  }

  createProduct(data) {
    return this.request.post(`/api/v1/products`, null, data);
  }

  editProduct({ id, ...data }) {
    return this.request.patch(`/api/v1/products/v2/${id}`, null, data);
  }

  deleteProduct(id) {
    return this.request.delete(`/api/v1/products/${id}`, null, {});
  }

  updateProductStatus(id) {
    return this.request.patch(`/api/v1/products/${id}/change-status`, null, {});
  }
//virtual categories
getVirtualProductType() {
    return this.request.get(`/api/v1/virtual-product-types`, null, null);
  }

  getVirtualProductFields(virtualProductId) {
    return this.request.get(`/api/v1/virtual-product-fields?virtual_product_type_id=${virtualProductId}`, null, null);
  }

  getCategories(data) {
    return this.request.get(`/api/v1/virtual-categories`, data, null);
  }
  getVirtualCategoriesById(id) {
    return this.request.get(`/api/v1/virtual-categories/${id}`, null, null);
  }

  createCategories(data) {
    return this.request.post(`/api/v1/virtual-categories`, null, data);
  }

  editCategory({ id, ...data }) {
    return this.request.patch(`/api/v1/virtual-categories/${id}`, null, data);
  }

  deleteCategory(id) {
    return this.request.delete(`/api/v1/virtual-categories/${id}`, null, {});
  }

  createSubCategories(data) {
    return this.request.post(`/api/v1/sub-categories`, null, data);
  }

  editSubCategory({ id, ...data }) {
    return this.request.patch(`/api/v1/sub-categories/${id}`, null, data);
  }

  deleteSubCategory(id) {
    return this.request.delete(`/api/v1/sub-categories/${id}`, null, {});
  }

  // getCatalogues(data) {
  //   return this.request.get(`/api/v1/catalogues`, data, null);
  // }

  createCatalogue(data) {
    return this.request.post(`/api/v1/catalogues`, null, data);
  }

  editCatalogue({ id, ...data }) {
    return this.request.patch(`/api/v1/catalogues/${id}`, null, data);
  }

  deleteCatalogue(id) {
    return this.request.delete(`/api/v1/catalogues/${id}`, null, {});
  }

  getTemplateThemes() {
    return this.request.get(`/api/v1/template/themes`, null, null);
  }

  updateTemplateTheme(data) {
    return this.request.patch(`/api/v1/template/themes`, null, data);
  }

  getStoreSeo() {
    return this.request.get(`/api/v1/template/store-seo`, null, null);
  }

  updateStoreSeo(data) {
    return this.request.patch(`/api/v1/template/store-seo`, null, data);
  }

  checkInvoiceShortCode() {
    return this.request.get(`/api/v1/template/short-code`, null, null);
  }

  updateInvoiceShortCode(data) {
    return this.request.patch(`/api/v1/template/short-code`, null, data);
  }

getAvailableDomains({ page = 1, page_size = 5 } = {}) {
  return this.request.get(`/api/v1/domains/available`, {
    page,
    page_size,
  });
}
  getConnectedDomains() {
    return this.request.get(`/api/v1/domains/connected`, null, null);
  }

  linkDomain({ domain_UUID, custom_domain }) {
    return this.request.patch(`/api/v1/domains/link/${domain_UUID}`, null, {
      custom_domain,
    });
  }

  unlinkDomain() {
    return this.request.patch(`/api/v1/domains/unlink-domain`, null, {});
  }

  reLinkDomain({ domain_UUID, custom_domain }) {
    return this.request.patch(`/api/v1/domains/relink/${domain_UUID}`, null, {
      custom_domain,
    });
  }

  getWalletBalance() {
    return this.request.get(`/api/v1/template/wallet-balance`, null, null);
  }

  checkHostingFee(data) {
    return this.request.get(`/api/v1/template/hosting-fees`, data, null);
  }

  checkDomainStatus() {
    return this.request.get(`/api/v1/template/check-domain`, null, null);
  }

  publishStore() {
    return this.request.patch(`/api/v1/template/publish-store`, null, {});
  }

  proceedHostingFee(data) {
    return this.request.post(
      `/api/v1/template/proceed-hosting-fee`,
      null,
      data
    );
  }

  createTemplatePreviewLink(data) {
    return this.request.post(`/api/v1/template/preview-link`, null, data);
  }

  getStocks({ stock_status, search, page, page_size }) {
    let data = {
      page,
      page_size,
    };
    if (stock_status) {
      data.stock_status = stock_status;
    }
    if (search) {
      data.search = search;
    }
    return this.request.get("/api/v1/product-stocks", data, null);
  }

  getStockHistory({ id, has_variant }) {
    let data = { has_variant };
    return this.request.get(
      `/api/v1/product-stocks/${id}/histories`,
      data,
      null
    );
  }

  updateStock(data) {
    return this.request.post(`/api/v1/product-stocks`, null, data);
  }

  getInventoryReport({ keyword, type }) {
    let data = {};
    if (type) {
      data.type = type;
    }
    if (keyword) {
      data.search = keyword;
    }
    return this.request.get(`/api/v1/inventory-report`, data, null);
  }

  getUsers({ keyword, from, to }) {
    let data = {
      from,
      to,
    };
    if (keyword) {
      data.search = keyword;
    }
    return this.request.get(`/api/v1/customers`, data, null);
  }

  getUserDetails(id) {
    return this.request.get(`/api/v1/customers/${id}`, null, null);
  }

  getUserOrders({ id, keyword, date_from, date_to }) {
    let data = {};
    if (keyword) {
      data.search = keyword;
    }
    if (date_from && date_to) {
      data.from = date_from;
      data.to = date_to;
    }
    return this.request.get(`/api/v1/customers/${id}/orders`, data, null);
  }

  updateUserStatus(id) {
    return this.request.patch(
      `/api/v1/customers/${id}/change-status`,
      null,
      {}
    );
  }

  getTotalIncomes() {
    return this.request.get(`/api/v1/income-reports/total`, null, null);
  }

  getIncomeReport({ period, date,search }) {
    return this.request.get(`/api/v1/income-reports/${period}`, { date,search }, null);
  }

  getOrderReport({ period, date,search }) {
    return this.request.get(`/api/v1/order-reports/${period}`, { date,search }, null);
  }

  getAdmins({ keyword, role }) {
    let data = {};
    if (keyword) {
      data.search = keyword;
    }
    if (role) {
      data.role = role;
    }
    return this.request.get(`/api/v1/admins`, data, null);
  }

  createAdmin(data) {
    return this.request.post(`/api/v1/admins`, null, data);
  }

  editAdmin({ id, ...data }) {
    return this.request.patch(`/api/v1/admins/${id}`, null, data);
  }

  deleteAdmin(id) {
    return this.request.delete(`/api/v1/admins/${id}`, null, {});
  }

  updateAdminStatus(id) {
    return this.request.patch(`/api/v1/admins/${id}/change-status`, null, {});
  }

  getAdmin(id) {
    return this.request.get(`/api/v1/admins/${id}`, null, null);
  }

  getAdminCounts() {
    return this.request.get(`/api/v1/admins/report/count`, null, null);
  }

  getAdminOrderCounts(id) {
    return this.request.get(`/api/v1/admins/${id}/orders-count`, null, null);
  }

  getAdminOrders({ id, keyword, date_from, date_to }) {
    let data = {};
    if (keyword) {
      data.search = keyword;
    }
    if (date_from && date_to) {
      data.date_from = date_from;
      data.date_to = date_to;
    }
    return this.request.get(`/api/v1/admins/${id}/orders`, data, null);
  }

  uploadMedia({ file, file_path }) {
    const data = new FormData();
    data.append("file", file);
    data.append("file_path", file_path);
    return this.request.post("/api/v1/files/upload-image", null, data, true);
  }

  getIncomeChart(filter) {
    return this.request.get(
      `/api/v1/dashboard/total-income-chart`,
      filter,
      null
    );
  }

  getTopProducts() {
    return this.request.get(
      `/api/v1/dashboard/top-selling-products`,
      null,
      null
    );
  }

  getGuideVideo() {
    return this.request.get(`/api/v1/dashboard/guide-video`, null, null);
  }

  createBrand(payload) {
    return this.request.post(`/api/v1/brands`, null, payload);
  }

  editBrand(payload) {
    return this.request.patch(`/api/v1/brands/${payload.id}`, null, payload);
  }

  getBrandList() {
    return this.request.get(`/api/v1/brands`, null, null);
  }

  updateBrandSort(payload) {
    return this.request.patch(`/api/v1/brands/update-sorting`, null, payload);
  }

  updateSocialLoginSort(id,payload) {
    return this.request.patch(
      `/api/v1/social-login-settings/${id}/swap-order`,
      null,
      payload
    );
  }
  
  updateCancelReasonSort(payload) {
    return this.request.patch(
      `/api/v1/cancel-reasons/update-sorting`,
      null,
      payload
    );
  }

  updateCitySort(payload) {
    return this.request.patch(
      `/api/v1/townships/update-sorting`,
      null,
      payload
    );
  }

  updatePaymentSort(id, swapId) {
    return this.request.patch(`/api/v1/payments/${id}/swap-order`, null, {
      swap_id: swapId,
    });
  }

  updateCitiesSwap(id, swapId) {
    return this.request.patch(`/api/v1/cities/${id}/swap-order`, null, {
      swap_id: swapId,
    });
  }

  updateCatalogueSort(payload) {
    return this.request.patch(
      `/api/v1/catalogues/actions/update-sorting`,
      null,
      payload
    );
  }

  updateCategorySort(payload) {
    return this.request.patch(
      `/api/v1/virtual-categories/update-sorting`,
      null,
      payload
    );
  }

  updateSubCategorySort(payload) {
    return this.request.patch(
      `/api/v1/sub-categories/update-sorting`,
      null,
      payload
    );
  }

  getDashboardCount() {
    return this.request.get(`/api/v1/dashboard/count`, null, null);
  }

  getPaymentTerms() {
    return this.request.get(`/api/v1/terms/payments`, null, null);
  }

  updatePaymentTerms(data) {
    return this.request.patch(`/api/v1/terms/payments`, null, data);
  }
  //delivery terms
  getDeliveryTerms() {
    return this.request.get(`/api/v1/terms/delivery`, null, null);
  }

  updateDeliveryTerms(data) {
    return this.request.patch(`/api/v1/terms/delivery`, null, data);
  }

  getForgetPwd() {
    return this.request.get(`/api/v1/auth/forget-password`, null, null);
  }
  storePublicOrderDetails(id) {
    return this.request.get(`/api/v1/template/hosting-fee/${id}`, null);
  }

  getAllDomainData() {
    return this.request.get(`/api/v1/domains/connected`, null, null);
  }

  //welcome message
  getWelcomeMessage() {
    return this.request.get(`/api/v1/terms/welcome-message`, null, null);
  }

  updateWelcomeMessage(data) {
    return this.request.patch(`/api/v1/terms/welcome-message`, null, data);
  }
  //otp usage
   getOtpUsageReport(filter) {
    return this.request.get(`/api/v1/otp-usage-reports`, filter, null);
  }
  //get notifications
  getNotification({ keyword, from, to,notification_type,page,page_size }) {
    let data = {
      from,
      to,
      page,
      page_size,
      notification_type,
    };
    if (keyword) {
      data.search = keyword;
    }
    return this.request.get(`/api/v1/payment-notifications`, data, null);
  }
 getNotificationDetails(id) {
    return this.request.get(`/api/v1/payment-notifications/${id}`, null);
  }

  // all payment api
   getAllAutoPaymentMethod() {
    return this.request.get(`/api/v1/auto-payment-methods`, null, null);
  }

   updateAutoPaymentSwap(id,payload) {
    return this.request.patch(
      `/api/v1/auto-payment-methods/${id}/swap-order`,
      null,
      payload
    );
  }

  checkPaymentType() {
    return this.request.get(`/api/v1/auto-payment-methods/check-status`, null, null);
  }

 SwitchPaymentMethod(payload) {
    return this.request.patch(
      `/api/v1/auto-payment-methods/switch-payment`,
      null,
      payload
    );
  }

   getServiceUsageHistory(filter) {
    return this.request.get(`/api/v1/auto-payment-methods/service-fees-histories`, filter, null);
  }

   getServiceUsageHistoryDetails(id) {
    return this.request.get(`/api/v1/auto-payment-methods/service-fees-histories/${id}`, null);
  }
  getExchangeRate(filter) {
    return this.request.get(`/api/v1/exchange-rates`, filter, null);
  }
   getExchangeRateHistory(id,filter) {
    return this.request.get(`/api/v1/exchange-rates/${id}/histories`, filter, null);
  }
   CalculateExchangeRate(id,params) {
    return this.request.get(`/api/v1/exchange-rates/${id}`, params, null);
  }

  getPaymentMaintenance() {
    return this.request.get(`/api/v1/maintenance`, null, null);
  }

   updatePaymentMaintenance(data) {
    return this.request.patch(`/api/v1/maintenance`, null, data);
  }

// reciving account

  getRecevingAccountList() {
    return this.request.get(`/api/v1/receiving-accounts`, null, null);
  }

  swapRecevingAccount(id,payload) {
    return this.request.patch(`/api/v1/receiving-accounts/${id}/swap-order`, null, payload);
  }

  updateStatusReceivingAccount(id) {
  return this.request.patch(`/api/v1/receiving-accounts/${id}/change-status`);
}
getRecevingAccountMethod(payload) {
    return this.request.get(`/api/v1/receiving-accounts/payment-methods`, payload, null);
  }

  createRecevingAccount(payload) {
    return this.request.post(`/api/v1/receiving-accounts`, null, payload);
  }


editReceivingAccount(id,payload) {
    return this.request.patch(`/api/v1/receiving-accounts/${id}`, null, payload);
  }

  //payment report
 getAllPaymentReportList(filter) {
    return this.request.get(`/api/v1/auto-payment-reports`, filter, null);
  }
 getAllPaymentReportTotal(filter) {
    return this.request.get(`/api/v1/auto-payment-reports/total`, filter, null);
  }
  getAllPaymentReportDetails(filter) {
    return this.request.get(`/api/v1/auto-payment-reports/details`, filter, null);
  }

  //withdraw report
getWithdrawReport(data) {
    return this.request.get("/api/v1/withdrawal-reports", data, null);
  }

getWithdrawReportDetails(id) {
    return this.request.get(`/api/v1/withdrawal-reports/${id}`, null, null);
 }

 getOrderCounts() {
    return this.request.get(`/api/v1/orders/counts`, null, null);
  }

firebaseSub(payload) {
    return this.request.post(`/api/v1/firebase/subscribe`, null, payload);
}

firebaseUnsub(payload) {
    return this.request.post(`/api/v1/firebase/unsubscribe`, null, payload);
  }

  // add cod 
getCodStatus() {
    return this.request.get(`/api/v1/cod-payment-method`, null, null);
}

updateCodeStatusChange() {
    return this.request.patch(`/api/v1/cod-payment-method/change-status`, null, {});
  }

  getDeliveryCheck() {
    return this.request.get(`/api/v1/orders/delivery-status`, null, null);
  }

  unpublishTemplate() {
  return this.request.patch(
    `/api/v1/template/unpublish-store`,
    {}
  );
}

//auto payment status change

ChangeStatusAutoQR(id,payload) {
  return this.request.patch(
    `/api/v1/auto-payment-methods/${id}/change-status`,
    {},
    payload
  );
}

// add on package settings

getAddOnPackageList() {
    return this.request.get("/api/v1/add-on-packages-settings", {});
}

updateAddOnStatus(id) {
  return this.request.patch(`/api/v1/add-on-packages-settings/${id}/status`, {});
}

getAddOnPackDetails(id) {
  return this.request.get(`/api/v1/add-on-packages-settings/${id}`, {});
}

updateAddOnPackData(id, body) {
  return this.request.patch(
    `/api/v1/add-on-packages-settings/${id}`,
    null,body
  );
}

//auto and manual profit report
getProfitDaily(params) {
    return this.request.get(`/api/v1/profit-report/daily`, params, null);
}
getProfitMonthly(params) {
    return this.request.get(`/api/v1/profit-report/monthly`, params, null);
}
getProfitYearly(params) {
    return this.request.get(`/api/v1/profit-report/yearly`, params, null);
}
getProfitReportTotal(params) {
    return this.request.get(`/api/v1/profit-report/total`, params, null);
}

getProfitReportDetails(id) {
  return this.request.get(`/api/v1/profit-report/${id}`, {});
}

//items-profit-report
getItemsProfitReport(data) {
    return this.request.get("/api/v1/profit-report/item", data, null);
  }

getItemsProfitReportDetailsList(data) {
  return this.request.get(`/api/v1/profit-report/item/orders`, data, null);
}
getItemsProfitReportDetails(data) {
  return this.request.get(`/api/v1/profit-report/item/details`, data,null);
}

//update tranx fee auto payment

updateEditTransFee(id,data) {
  return this.request.patch(`/api/v1/auto-payment-methods/${id}`, null, data);
}

getRefundOrderList(params) {
  return this.request.get(`/api/v1/orders`,params, null);
}

//refund order request
refundOrderRequest(id) {
  return this.request.patch(`/api/v1/orders/${id}/refund`, {});
}

//check qr 

findByQRScan(payload) {
    return this.request.post(`/api/v1/add-on-packages-settings/order-qr`, null, payload,true);
  }

checkQRScan() {
  return this.request.get(`/api/v1/add-on-packages-settings/qr`,null, null);
}
generateQRScan(params) {
  return this.request.get(`/api/v1/add-on-packages-settings/generate-qr`, params, null);
}


//sort variant 
  getProductVariant(id, variantId) {
    return this.request.get(`/api/v1/products/${id}/${variantId}/product-variants`, null, null);
  }

firstLayerSort(id, data) {
  return this.request.patch(
    `/api/v1/products/${id}/first-layer-sort`,null,
    data
  );
}

secondLayerSort(productId, data) {
  return this.request.patch(
    `/api/v1/products/${productId}/second-layer-sort`,null,
    data
  );
}

  /**
   * After a successful login, save session id into
   * request object, which will be send in Headers
   */
  setSessionToken(token) {
    this.request.setSessionToken(token);
  }
}

const api = new Api();

export default api;
